<app-stat-linechart
    [chartData]="chartData"
    [titleArray]="chartTitles"
    [showTooltip]="true"
  ></app-stat-linechart>